import Service from "./Service";
const baseurl = '/api/historia-items-aiepi';
export default {
    index() {
        return Service.get(`${baseurl}`);
    },
    showBySec(id) {
        return Service.get(`${baseurl}/show-by-sec/${id}`);
    },
    store(obj) {
        return Service.post(`${baseurl}/store`, obj);
    },
    show(id) {
        return Service.get(`${baseurl}/show/${id}`);
    },
    update(obj) {
        return Service.put(`${baseurl}/update`, obj);
    },
    delete(id) {
        return Service.delete(`${baseurl}/delete/${id}`);
    },
    estado(id) {
        return Service.put(`${baseurl}/update-estado/${id}`);
    },
}